// extracted by mini-css-extract-plugin
export default {"image":"styles_image__KyIGR","title":"styles_title__65lgg","desc":"styles_desc__LC+Re","game":"styles_game__QXfVt"};